<!--  -->
<template>
  <div>
    <div class="header" :style="style" :class="{ color: color }">
      <div class="header-top">
        <a href="/" id="logo">
          <img
            src="@/assets/yinlai.png"
            alt=""
            style="width: 66px; height:30px"
          />
        </a>
        <span style="font-size: 24px; height: 66px; line-height: 66px;margin-left:5px"
          >杭州盈来科技有限公司</span
        >
      </div>
    </div>
    <!-- <div style="height: 66px; width: 100%"></div> -->
  </div>
</template>
<script>
export default {
  components: {},
  name: "ComponentName",
  data() {
    return {
      style: {
        backgroundColor: "",
      },
      color: false,
    };
  },
 mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      // let offsetTop = document.querySelector(".header").offsetTop;
      //设置背景颜色的透明读
      if (scrollTop) {
        // this.style.backgroundColor = `rgba(61, 61, 61,${scrollTop /
        //   (scrollTop + 80)})`;
        this.style.backgroundColor = "#fff";
        this.color = true;
      } else if (scrollTop == 0) {
        this.style.backgroundColor = "transparent";
        this.color = false;
      }
    },
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>
<style lang="less" scoped>
.header {
  // background: #fff;
  color:#fff;
  height: 66px;
  width:100%;
  display: flex;
  flex-direction: column;
  // position: sticky;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
}
.color {
  color: #000;
}
#logo {
  display: block;
  float: left;
  height: 30px;
  margin-top: 20px;
  margin-left: 50px;
}
</style>
